import { Typography, Box } from "@mui/material";

import { CopyToClipboard } from "components/formFields/frm/CopyToClipboard";
import { VSpace } from "components/utility/VSpace";

import { i18n } from "services/i18nService";

import { SHIPSTATION_XML_LINK } from "appConstants";

const emphasis = {
  padding: "4px 4px",
  borderRadius: "4px",
};

const emphasisText = {
  fontFamily: "monospace",
  fontWeight: "bold",
  fontSize: "1.1rem",
};

export function Description(props) {
  const { settingsValues } = props;
  return (
    <>
      <ol style={{ marginTop: 0 }}>
        <li>{i18n(`shipStation.1`)}</li>
        <li>{i18n(`shipStation.2`)}</li>
        <Box sx={emphasis}>
          <Typography sx={emphasisText} component="span">
            {settingsValues.userName}
          </Typography>
          <CopyToClipboard copyText={settingsValues.userName} />
        </Box>
        <li>{i18n(`shipStation.3`)}</li>
        <Box sx={emphasis}>
          <Typography sx={emphasisText} component="span">
            {settingsValues.password}
          </Typography>
          <CopyToClipboard copyText={settingsValues.password} />
        </Box>
        <li>{i18n(`shipStation.4`)}</li>
        <Box sx={emphasis}>
          <Typography
            sx={{ fontWeight: "bold", fontSize: "1.1rem" }}
            component="span"
          >
            {SHIPSTATION_XML_LINK}
          </Typography>
          <CopyToClipboard copyText={SHIPSTATION_XML_LINK} />
        </Box>
        <li>{i18n(`shipStation.5`)}</li>
        <li>{i18n(`shipStation.6`)}</li>
        <li>{i18n(`shipStation.7`)}</li>
        <VSpace space={1} />
        <Typography component="span">{i18n(`shipStation.footer`)}</Typography>
      </ol>
    </>
  );
}
